import React from "react";
import {PlusOutlined} from "@ant-design/icons";
import {Button} from "antd";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../../store/features/loadingSlice";
import {CaseListingExcelDownload} from "../CaseListingExcelDownload";

const TechnicialListingHeader = ({tableFilters}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleWorkforceExcelDownload = () => {
        dispatch(SET_IS_API_CALLED("Downloading Excel Data"));
        CaseListingExcelDownload({
            dateFrom: tableFilters?.dateFrom ?? null,
            dateTo: tableFilters?.dateTo ?? null
        }).finally(() => {
            dispatch(SET_IS_API_CALLED_FINISHED());
        });

    }

    return (
        <>
            <div className="flex justify-between items-center">
                <div>
                    <p className="font-bold text-xl">List of Technicians (By Cases)</p>
                </div>
                <div className="flex justify-between items-center gap-3">
                    <img
                        src={"/assets/icon-excel.svg"}
                        className=" cursor-pointer"
                        onClick={handleWorkforceExcelDownload}
                        width={30}
                        height={30}
                        alt=""
                    />
                    <Button
                        className="bg-medium-blue-100 text-white"
                        onClick={() => navigate("/wf-create-case")}
                        icon={<PlusOutlined/>}
                    >
                        Create Case
                    </Button>
                </div>
            </div>
        </>
    );
};

export default TechnicialListingHeader;
